import { PipelineStatus, ReplayRequestType } from './enums';

export default class ReplayRequest {
  public id: number;
  public jobId: number;
  public activityDefinitionId: number;
  public activityEventId?: number;
  public replayRequestType: ReplayRequestType;
  public requestedByUserId: string;
  public requestDateTime: Date;
  public status: PipelineStatus | null;
  public useCompletedReferences?: boolean;

  constructor(
    jobId?: number,
    activityDefinitionId?: number,
    replayRequestType?: ReplayRequestType,
    requestedByUserId?: string,
    requestDateTime?: Date,
    activityEventId?: number,
    id?: number,
    useCompletedReferences?: boolean,
  ) {
    this.id = id || 0;
    this.jobId = jobId || 0;
    this.activityDefinitionId = activityDefinitionId || 0;
    this.activityEventId = activityEventId || undefined;
    this.replayRequestType = replayRequestType || ReplayRequestType.Isolated;
    this.requestedByUserId = requestedByUserId || '';
    this.requestDateTime = requestDateTime || new Date();
    this.status = null;
    this.useCompletedReferences = useCompletedReferences ?? false;
  }
}
